module.exports = __webpack_public_path__ + "static/bengaluru-7c4f58dce64ae236a16616734bfda343.png";